import React, { useState, useContext, useEffect } from 'react';
import ConnectContext from '../context/connectContext';
import ChatConnectRoomItem from './ChatConnectRoomItem';

import './chatconnectlist.scss';

const ChatConnectList = () => {
  const [chatRooms, setChatrooms] = useState({});
  const { sb, currentUser } = useContext(ConnectContext);

  const _chatItemClick = activeRoom => {
    window.location.href = `/chat?room=${activeRoom.url}`;
  };

  const _listChannel = () => {
    const channelListQueryValue = sb.GroupChannel.createMyGroupChannelListQuery();
    channelListQueryValue.includeEmpty = true;
    channelListQueryValue.limit = 5;
    if (channelListQueryValue.hasNext) {
      channelListQueryValue.next((channelList, error) => {
        if (error) {
          return;
        }
        const channelListActive = Object.keys(channelList).map(key => {
          const cl = channelList[key];
          const buyer = cl.inviter.userId === currentUser.userId;
          if (!buyer) {
            if (cl.lastMessage === null) {
              return null;
            }
          }
          return cl;
        });
        setChatrooms(channelListActive);
      });
    }
  };

  const _showTotalUnread = () => {
    sb.getTotalUnreadMessageCount((count, error) => {
      if (error) {
        return;
      }
      const docTitle = document.title.replace(/ *\([^)]*\) */g, '');
      const unreadElement = document.getElementById('total-unread-message');
      if (count === 0) {
        unreadElement.setAttribute('style', 'display: none');
        document.title = docTitle;
      } else {
        unreadElement.setAttribute('style', 'display: block');
        unreadElement.innerHTML = count;
        document.title = `(${count}) ${docTitle}`;
      }
    });
  };

  useEffect(() => {
    _listChannel();
    _showTotalUnread();
    const ChannelHandler = new sb.ChannelHandler();
    ChannelHandler.onChannelChanged = () => {
      _listChannel();
      _showTotalUnread();
    };
    sb.addChannelHandler('CHANNEL_CHANGED_CONNECT', ChannelHandler);
  }, [currentUser]);

  const ChatConnectRoomItems = Object.keys(chatRooms).map(key => {
    const chatRoom = chatRooms[key];
    if (chatRoom !== null) {
      return (
        <ChatConnectRoomItem
          key={key}
          coverUrl={chatRoom.coverUrl}
          roomDetail={chatRoom}
          chatItemClick={_chatItemClick}
        />
      );
    }
    return null;
  });
  return <div className="chat-connect-list">{ChatConnectRoomItems}</div>;
};

export default ChatConnectList;
